const ASSET = "https://customer-assets.emergentagent.com/job_mangawhai-126/artifacts";
const ASSET_ALT = "https://customer-assets-eiarnc6j.emergentagent.net/job_mangawhai-126/artifacts";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Estate (Stage Two) is hidden until the legal structure is confirmed
export const SHOW_ESTATE = false;

export const PROPERTY = {
  name: "The 126 House",
  address: "126 Robert Hastie Drive, The Sanctuary",
  locality: "Mangawhai Heads, New Zealand",
  architect: "Wingates",
};

export const HERO_RENDER = `${ASSET}/qlfddatu_RENDER%2002_HD.png`;
export const HERO_PHOTO = `${ASSET_ALT}/7ebrmckx_F001D650-3349-42F4-AEBD-97EF214A3249%202.jpg`;

export const RENDERS = [
  `${ASSET}/qlfddatu_RENDER%2002_HD.png`,
  `${ASSET}/r38yb55c_RENDER%2003_HD.png`,
  `${ASSET}/fn5cchks_RENDER%2004_HD.png`,
  `${ASSET}/av5yw3uo_RENDER%2005_HD.png`,
  `${ASSET}/6skwglxg_RENDER%20INT%2001_HD.png`,
  `${ASSET}/7ciqnnm3_RENDER%20INT%2002_HD.png`,
];

export const MANGAWHAI_REEL = [
  `${ASSET}/281m0i1s_MangawhaiHeads_4512.jpg`,
  `${ASSET}/9n9b736w_mangawhai%20Surf%20.jpg`,
];

export const FLOOR_PLANS = [
  { src: `${ASSET}/l4zjh291_Floor%20Plans%201.png`, alt: "Ground floor plan", label: "Ground Floor" },
  { src: `${ASSET}/ss5aez8u_Floor%20Plans%202.png`, alt: "Basement floor plan", label: "Basement" },
  { src: "/assets/site-plan.jpg", alt: "Site plan", label: "Site Plan" },
];

export const ACCOMMODATION = [
  { level: "Ground floor", rooms: "Open-plan living, kitchen and dining with pantry · main bedroom with walk-in wardrobe and ensuite · two further bedrooms · studio · media room · bathroom · guest WC · laundry · deck · garage" },
  { level: "Basement", rooms: "Multipurpose room · gym · sauna · spa pool · workshop · storage" },
  { level: "Site", rooms: "Approximate boundary shown by the red dashed line on the site plan" },
];

export const PROGRESS_VIDEO = `${ASSET}/55fwr5hc_New%20progress%20video.mov`;
export const PROGRESS_GRID = [
  { src: `${ASSET_ALT}/x2u80de0_F6CE29F4-8116-438C-940B-CA169F32420E%202.jpg`, alt: "Deck and valley view" },
  { src: `${ASSET_ALT}/stbk89yp_D46D5BC3-64BE-4FC3-93DB-14490120E292%202.jpg`, alt: "Full exterior with cantilever" },
  { src: `${ASSET_ALT}/3bqz9fag_71F8ED83-BABC-4D11-B3DF-4A4B30EF22E0%202.jpg`, alt: "Side elevation with landscaping" },
  { src: `${ASSET_ALT}/zv80y0yy_4FB6381A-3CAF-4A5C-8E4B-DC2DBD3D6444.jpg`, alt: "Rear elevation with native planting" },
];

export const NIC_PORTRAIT = `${ASSET}/7t07ggeu_Nic%20IMAGE%20.webp`;
export const PDF_URL = `${ASSET}/8yj2tupk_RH_Booklet_Final_260416.pdf`;

export const LINZ_5M_URL = "https://www.linz.govt.nz/guidance/overseas-investment/ways-invest/pathways-migrants-and-visa-holders/investing-residential-land-over-5-million";

export const AGENT = { name: "Sarah Dyer", company: "Bayleys", email: "sarah.dyer@bayleys.co.nz", phone: "+64 21 417 063" };

export const LIFESTYLE_REEL = [
  { src: `${ASSET}/qrpzh0n4_Mangawhai%20Surf%20.jpg`, label: "On the wave" },
  { src: `${ASSET}/mme6li4f_Family%20photo.jpg`, label: "On the shore" },
];

export const KEY_FACTS = [
  { label: "Bedrooms", value: "3 + studio" },
  { label: "Bathrooms", value: "3 + guest WC" },
  { label: "Wellness", value: "Gym, sauna & spa" },
  { label: "Land", value: "2.5 acres" },
  { label: "Asking price", value: "NZ$3.8M" },
];

export const TRAVEL_TIMES = [
  { place: "Mangawhai surf beach", time: "5 min" },
  { place: "Mangawhai village", time: "11 min" },
  { place: "Te Arai Links", time: "approx. 20 min" },
  { place: "Tara Iti Golf Club", time: "approx. 20 min" },
  { place: "Auckland CBD", time: "90 min" },
  { place: "Auckland Airport", time: "approx. 1 hr 50 min" },
];

export const STAGES = [
  {
    id: "stage-1",
    name: "The Residence",
    stage: "Stage One",
    price: "NZ$3.8M",
    basis: "Asking price",
    rows: [
      { item: "Main residence", detail: "Three bedrooms plus studio and media room, as shown on the ground floor plan" },
      { item: "Garage and connecting structures", detail: "Garage, connecting canopy and deck" },
      { item: "Landscaping", detail: "Native landscaping as designed" },
      { item: "Status", detail: "Construction in its final stages — contact the agent for current handover timing" },
      { item: "Furniture", detail: "Available by separate negotiation; not included in the price" },
      { item: "GST", detail: "Please confirm GST treatment with the agent" },
    ],
    eligibility: "Generally available to New Zealand citizens, residence-class visa holders who are ordinarily resident in New Zealand, and Australian and Singaporean citizens, without Overseas Investment Office consent.",
    cta: "Arrange a private viewing",
    variant: "stage1",
  },
  {
    id: "stage-2",
    name: "The Estate",
    stage: "Stage Two",
    price: "NZ$5.8M",
    basis: "Indicative package price",
    rows: [
      { item: "Main residence", detail: "As The Residence" },
      { item: "Additional scope", detail: "To be confirmed" },
      { item: "Status", detail: "Indicative programme on request" },
      { item: "Furniture", detail: "Available by separate negotiation; not included in the price" },
    ],
    eligibility: "Overseas buyers should take independent legal advice on eligibility before making an offer.",
    cta: "Register interest",
    variant: "stage2",
  },
];

export const OVERSEAS_FAQ = [
  {
    q: "Who can buy The Residence without OIO consent?",
    a: "New Zealand citizens, residence-class visa holders who are ordinarily resident in New Zealand, and Australian and Singaporean citizens can generally buy residential land without Overseas Investment Office (OIO) consent. Other residence-class visa holders may still require consent. Most other overseas persons cannot buy residential land unless an exemption or pathway applies.",
  },
  {
    q: "What is the NZ$5M+ residential pathway?",
    a: "Since March 2026, holders of Active Investor Plus, Investor 1 or Investor 2 residence visas may apply for OIO consent to buy residential land with a dwelling for an agreed purchase price above NZ$5M, or to buy land and build a new dwelling where the combined qualifying costs exceed NZ$5M. LINZ guidance states that renovations or improvements to an existing home do not count toward the threshold where the original purchase price is NZ$5M or less, and furniture and other chattels are excluded.",
  },
  {
    q: "Does buying this home meet the Active Investor Plus investment requirement?",
    a: "No. Buying a home and meeting the visa investment requirement are separate matters. Immigration New Zealand excludes personal-use assets, such as a residence, from acceptable Active Investor Plus investments.",
  },
  {
    q: "Is OIO consent needed, and how long does it take?",
    a: "Where consent is required, the sale and purchase agreement should be conditional on obtaining it. LINZ assesses applications under the national interest test and publishes indicative timeframes and fees.",
  },
  {
    q: "Are there conditions while I own the property?",
    a: "Consent may carry ongoing conditions, which can relate to your visa or residence status. Your lawyer should confirm how these apply to you, including if you later become a permanent resident.",
  },
  {
    q: "What advice should I take?",
    a: "Engage a New Zealand property lawyer and a licensed immigration adviser before making an offer. Our agent can introduce trusted advisers on request.",
  },
];

export const BOOKING_VARIANTS = {
  viewing: {
    eyebrow: "Private Viewing",
    title: "Arrange a Private Viewing",
    copy: "Leave your details and Sarah Dyer of Bayleys will contact you to arrange a time — including while you are in the area.",
    submit: "Request Viewing",
    interest: "general",
    source: "viewing-request",
  },
  stage1: {
    eyebrow: "The Residence — Stage One",
    title: "Arrange a Private Viewing",
    copy: "Leave your details and Sarah Dyer of Bayleys will contact you to arrange a private viewing of The Residence.",
    submit: "Request Viewing",
    interest: "residence",
    source: "stage-1-viewing",
  },
  stage2: {
    eyebrow: "The Estate — Stage Two",
    title: "Register Your Interest",
    copy: "Leave your details and our agent will contact you with information on The Estate option.",
    submit: "Register Interest",
    interest: "estate",
    source: "stage-2-eoi",
  },
};

export const INTEREST_OPTIONS = [
  { value: "general", label: "General enquiry" },
  { value: "residence", label: "The Residence — NZ$3.8M" },
  ...(SHOW_ESTATE ? [{ value: "estate", label: "The Estate — NZ$5.8M" }] : []),
];

export const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 1, ease: [0.22, 1, 0.36, 1] },
};

export const fadeIn = {
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: { once: true },
  transition: { duration: 1.2 },
};

export const openViewing = (variant = "viewing") =>
  window.dispatchEvent(new CustomEvent("open-viewing", { detail: variant }));
